import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BankingInfo, UIViewOption } from '../models/common-data-types';
import { PaymentOption } from '../models/payment-options';

@Injectable({
  providedIn: 'root'
})
export class PaymentsConfigurationService {

  constructor(private httpClient: HttpClient) { }

  getPaymentFrequencies(): Observable<UIViewOption[]>{
    return this.httpClient.get<UIViewOption[]>('/selfcare/payment-frequencies');
  }

  getPaymentMethods(): Observable<UIViewOption[]>{
    return this.httpClient.get<UIViewOption[]>('/selfcare/payment-methods');
  }

  getPaymentOptions(paymentMethod: string): Observable<PaymentOption[]>{
      return this.httpClient.get<PaymentOption[]>('/selfcare/payment-options?paymentMethod=' + paymentMethod);
  }

  getBankingDetails(): Observable<BankingInfo>{
    return this.httpClient.get<BankingInfo>('/selfcare/payment-details');
  }
}
